import {
    mailboxQuotaPercentFull,
    mailboxQuotaBlockSend,
    mailboxQuotaWarning,
    viewStorage,
} from './showNotificationOnMailboxQuotaWarning.locstring.json';
import loc, { format } from 'owa-localize';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import getAccountInformationService from '../../services/getAccountInformationService';
import { getUserConfiguration } from 'owa-session-store';
import UnlimitedUnsignedInteger from 'owa-service/lib/contract/UnlimitedUnsignedInteger';
import { logUsage } from 'owa-analytics';

const SHOW_NOTIFICATION_PERCENTAGE = 90;
const SHOW_ALERT_PERCENTAGE = 98;

/**
 * show notification on mailbox quota warning
 */
export default function showNotificationOnMailBoxQuotaWarning() {
    getAccountInformationService().then(jsonResponse => {
        let totalMbxSize: UnlimitedUnsignedInteger;

        if (!jsonResponse.AccountInfo.Statistics || !jsonResponse.AccountInfo.Mailbox) {
            return;
        }

        const currentMbxUsed = jsonResponse.AccountInfo.Statistics.TotalItemSize.Value;
        const userConfiguration = getUserConfiguration();
        const shouldUseDatabaseDefault =
            !userConfiguration?.SessionSettings?.IsBposUser &&
            jsonResponse.AccountInfo.Mailbox.UseDatabaseQuotaDefaults;

        // To align with Outlook client, Exchange Admin Center(EAC), OWA for Exchange on-prem the customer is asking to use
        // ProhibitSendQuota (instead of ProhibitSendReceiveQuota), as it is used everywhere else.
        if (shouldUseDatabaseDefault) {
            totalMbxSize = jsonResponse.AccountInfo.Statistics.DatabaseProhibitSendQuota;
        } else {
            totalMbxSize = jsonResponse.AccountInfo.Mailbox.ProhibitSendQuota;
        }

        const percentFull = (currentMbxUsed / totalMbxSize.Value) * 100;

        if (percentFull < SHOW_NOTIFICATION_PERCENTAGE || totalMbxSize.IsUnlimited) {
            return;
        }

        logUsage('TnS_MailboxQuotaWarning', [Math.round(percentFull)]);

        let notificationText = format(loc(mailboxQuotaPercentFull), percentFull.toFixed(2));

        notificationText +=
            percentFull >= SHOW_ALERT_PERCENTAGE
                ? loc(mailboxQuotaBlockSend)
                : loc(mailboxQuotaWarning);
        lazyShowNotification.importAndExecute(
            'mailboxQuotaWarningNotification',
            'MailModuleNotificationBarHost',
            notificationText,
            {
                primaryActionText: loc(viewStorage),
                allowAutoDismiss: false,
                shouldShowDismissIcon: true,
                minWidth: 0, // Set min-width to 0 so notification bar can shrink
                notificationCallback: reason => {
                    if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                        logUsage('MailboxCleanup_NavigateTo', ['OldMailboxQuotaWarning']);
                        lazyMountAndShowFullOptions.importAndExecute('general', 'storage');
                    }
                },
            }
        );
    });
}
